module.exports = __webpack_public_path__ + "img/icon_re.f760ea5e.png";